<template>
    <v-dialog v-model="showDialog" max-width="410" persistent>
        <v-tabs-items class="transparent" v-model="tab" align-center justify-center>
            <v-tab-item>
                <v-card :loading="loading">
                        <v-card-title class="justify-space-between">
                            {{requestTitle}}
                            <v-btn fab text small @click="$emit('canceled')"><v-icon class="text-right text--secondary">close</v-icon></v-btn>
                        </v-card-title>
                        <v-card-subtitle class="mt-1">
                            {{requestSubtitle}}
                        </v-card-subtitle>
                        <v-card-text>
                            <v-form
                                ref="requestForm"
                            >
                                <v-textarea
                                    :readonly="loading"
                                    outlined
                                    label="Message"
                                    hint="Optional"
                                    v-model="message"
                                ></v-textarea>
                            </v-form>
                            <v-btn
                                class="mt-2 text-body-1" 
                                large 
                                elevation="0"
                                color="primary"
                                block
                                @click="sendRequest"
                            >
                                Submit Request
                            </v-btn>
                            <!-- <v-btn
                                    class="mt-2 text-body-1" 
                                    large
                                    text
                                    elevation="0"
                                    color="primary"
                                    block
                                    @click="$emit('canceled')"
                                >
                                    Cancel
                            </v-btn> -->
                        </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                        <v-card-title>
                            Submitted successfully!
                        </v-card-title>
                        <v-card-subtitle class="mt-1">
                            Your request was submitted successfully. A member of our team will get in touch with you shortly.
                        </v-card-subtitle>
                        <v-card-text>
                            <v-btn
                                class="mt-2 text-body-1" 
                                large 
                                elevation="0"
                                color="primary"
                                block
                                @click="$emit('canceled')"
                            >
                                Okay
                            </v-btn>
                        </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
    name: 'SendRequestDialog',
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        requestType: {
            type: String,
            default: 'CONTACT_US',
        },
    },
    computed: {
        ...mapGetters(['businessProfile', 'userProfile', 'loggedInUsersUid', 'selectedBusinessProfileId']),
        requestTitle() {
            let title = '';
            switch(this.requestType) {
            case 'CRM_INTEGRATION':
                title = `CRM Integration Access Request`;
              break;
            case 'INDUSTRY_SPECIFIC_PROFILE':
                title = `Industry Specific Profile Access Request`;
              break;
            case 'CONTACT_US':
                title = `Contact Us`;
              break;
            case 'CUSTOM_CARD_DESIGN':
                title = `Interested in a Custom Card Design?`;
              break;
            case 'BULK_UPLOAD':
                title = `Bulk Upload Request`;
              break;
            default:
                title = `Contact Us`;
          }
          return title;
        },
        requestSubtitle() {
            let subtitle = '';
            switch(this.requestType) {
            case 'CRM_INTEGRATION':
                subtitle = `Add any relevant information and submit a request with our support team.`;
              break;
            case 'INDUSTRY_SPECIFIC_PROFILE':
                subtitle = `Add any relevant information and submit a request with our support team.`;
              break;
            case 'CONTACT_US':
                subtitle = `Add any relevant information and submit a request with our support team.`;
              break;
            case 'CUSTOM_CARD_DESIGN':
                subtitle = `Contact the Pappyon Team below for a quote and we can work with you to bring a custom ConnectionCard design to life.`;
              break;
            case 'BULK_UPLOAD':
                subtitle = `Add any relevant information and submit a request with our support team.`;
              break;
            default:
                subtitle = `Add any relevant information and submit a request with our support team.`;
          }
          return subtitle;
        }
    },
    data() {
        return {
            message: '',
            tab: 0,
            loading: false,
        };
    },
    created() {
        this.initializeComponent();
    },
    methods: {
        initializeComponent() {
            this.loading = false;
            this.tab = 0;
            this.message = '';
        },
        async sendRequest() {
            if(this.loading)
                return;
            try{
                this.loading = true;
                const sendEmail = getHttpsCallable('sendEmail');
                const response = await sendEmail({ 
                    title: `Support Request by ${this.businessProfile.businessName} (from the "${this.requestTitle}" section)`,
                    body: this.renderRequestBody(),
                });
                if (response.data.error != undefined) {
                    console.log('Error while calling sendEmail ');
                    console.log(response.data.error);
                }
                else {
                    //Reuest sent successfully
                    console.log(response.data);
                }
                this.tab = 1;
                this.loading = false;
            } catch(error) {
                this.loading = false;
                console.log(error);
            }
        },
        renderRequestBody() {
            let body = `This email was triggered from the Pappyon Business Portal.\n\n\nThe support request details are as follows:\n\nUser's Reference Id (uid): ${ this.loggedInUsersUid}\nUser's First Name: ${this.userProfile.firstName}\nUser's Last Name: ${this.userProfile.lastName}\nUser's Email: ${this.userProfile.email}\nBusiness Pofile Reference Id: ${this.selectedBusinessProfileId}\nBusiness Name: ${this.businessProfile.businessName}\nType of Request/Enquiry: ${this.requestTitle}\n\n\n`;
                if (this.message.trim() != '') {
                    body = body + `Message from the User:\n${this.message}`;
                }
                return body;
        },
    },
     watch: {
        showDialog: function(newVal) {
            if (newVal) {
                this.initializeComponent();
            }
        }
    },
}
</script>